import React from "react";
import Home from "../components/home/Home";
const Index = () => <Home />;

export default Index;
